// "use client";

// import DatePicker from "react-datepicker";
// import { useFormContext } from "react-hook-form";

// export const RHFDatePicker = ({
//     name = "date",
//     methods: parentMethods,
//     ...other
// }) => {
//     const methods = useFormContext();

//     if (!methods && !parentMethods) {
//         throw new Error("Datepicker needs RHF methods");
//     }

//     return (
//         <DatePicker
//             selected={(methods || parentMethods)["watch"]("date")}
//             onChange={(date) => {
//                 (methods || parentMethods)["setValue"]("date", date);
//             }}
//             {...other}
//         />
//     );
// };

"use client";

import DatePicker from "react-datepicker";
import { useFormContext, Controller } from "react-hook-form";
import "react-datepicker/dist/react-datepicker.css";
import { getImageURL } from "@/lib";

export const RHFDatePicker = ({
  name = "date",
  methods: parentMethods,
  placeholder,
  className,
  disabled = false,
  onChange,
  ...other
}) => {
  const methods = useFormContext();
  const formMethods = methods || parentMethods;

  if (!formMethods) {
    throw new Error("RHFDatePicker needs RHF methods");
  }

  return (
    <Controller
      name={name}
      control={formMethods.control}
      render={({ field, fieldState: { error } }) => (
        <div className="date-picker-wrapper">
          <DatePicker
            {...field}
            selected={field.value}
            onChange={(date) => {
              field.onChange(date);

              if (onChange) {
                const syntheticEvent = {
                  target: { value: date },
                };
                onChange(syntheticEvent);
              }
            }}
            placeholderText={placeholder}
            className={`${className || ""} ${error ? "error" : ""}`}
            disabled={disabled}
            dateFormat="dd/MM/yyyy"
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
            portalId="root-portal"
            {...other}
          />
          <img
            src={getImageURL(
              "/upload/media/grievance_form_icon_1756882333_1768298301.webp"
            )}
          />
          {error && (
            <span
              className="error-message"
              style={{ color: "red", fontSize: "12px" }}
            >
              {error.message}
            </span>
          )}
        </div>
      )}
    />
  );
};
